<script setup lang="ts">
withDefaults(
  defineProps<{
    name:
      | 'learn'
      | 'progress'
      | 'sources'
      | 'settings'
      | 'back'
      | 'chevron'
      | 'chevron-down'
      | 'close'
      | 'external'
      | 'swap'
      | 'hint'
      | 'send'
      | 'backspace';
    size?: number;
  }>(),
  { size: 24 },
);
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="name === 'learn'">
      <path
        d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
      />
      <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" />
      <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" />
    </template>

    <template v-else-if="name === 'progress'">
      <path d="M16 7h6v6" />
      <path d="m22 7-8.5 8.5-5-5L2 19" />
    </template>

    <template v-else-if="name === 'sources'">
      <path d="M12 7v14" />
      <path
        d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
      />
    </template>

    <template v-else-if="name === 'back'">
      <path d="M19 12H5" />
      <path d="m12 19-7-7 7-7" />
    </template>

    <template v-else-if="name === 'chevron'">
      <path d="m9 18 6-6-6-6" />
    </template>

    <template v-else-if="name === 'chevron-down'">
      <path d="m6 9 6 6 6-6" />
    </template>

    <template v-else-if="name === 'close'">
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </template>

    <template v-else-if="name === 'external'">
      <path d="M7 7h10v10" />
      <path d="M7 17 17 7" />
    </template>

    <template v-else-if="name === 'swap'">
      <path d="m16 3 4 4-4 4" />
      <path d="M20 7H4" />
      <path d="m8 21-4-4 4-4" />
      <path d="M4 17h16" />
    </template>

    <template v-else-if="name === 'hint'">
      <path
        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"
      />
      <path d="M9 18h6" />
      <path d="M10 22h4" />
    </template>

    <template v-else-if="name === 'send'">
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </template>

    <template v-else-if="name === 'backspace'">
      <path d="M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z" />
      <path d="m18 9-6 6" />
      <path d="m12 9 6 6" />
    </template>

    <template v-else>
      <path d="M14 17H5" />
      <path d="M19 7h-9" />
      <circle cx="17" cy="17" r="3" />
      <circle cx="7" cy="7" r="3" />
    </template>
  </svg>
</template>
